import {
  ImprovementsAction,
  ImprovementsState,
} from 'pages/Improvements/_store';
import * as R from 'remeda';
import { timeUtility } from 'utility';

// Default actionboard week: same factory as the deleted store/page/actionboard
// reducer used — the current week stepped back one year, so the simulate tab
// opens on a populated historical window rather than an empty future date.
const currentWeek = timeUtility.factory<Time.Week>({
  ...timeUtility.toTimeDate(new Date()),
  type: 'week',
});
const defaultActionboardSelectedWeek = timeUtility.step({
  timeDate: currentWeek,
  step: 'previous',
  stepSize: 'year',
});

const initialState: ImprovementsState = {
  activeTabId: 'suggestions',
  selectedSuggestionId: null,
  selectedActionId: null,
  // null = "All" for each tab's dropdown; persists across tab switches.
  suggestionsAreaId: null,
  actionsAreaId: null,
  actionboard: {
    selectedWeek: defaultActionboardSelectedWeek,
    selectedEntityId: null,
  },
};

const improvementsReducer = (
  state: ImprovementsState = initialState,
  action: ImprovementsAction,
): ImprovementsState => {
  switch (action.type) {
    case 'page/improvements/SET_ACTIVE_TAB_ID':
      return R.set(state, 'activeTabId', action.payload);
    case 'page/improvements/SET_SELECTED_ACTION_ID':
      return R.set(state, 'selectedActionId', action.payload);
    case 'page/improvements/SET_SELECTED_SUGGESTION_ID':
      return R.set(state, 'selectedSuggestionId', action.payload);
    // Per-tab area-filter setters. Payload is `null` (All), a real
    // improvementArea id, or the `UNASSIGNED_AREA_ID` sentinel.
    case 'page/improvements/SET_SUGGESTIONS_AREA_ID':
      return R.set(state, 'suggestionsAreaId', action.payload);
    case 'page/improvements/SET_ACTIONS_AREA_ID':
      return R.set(state, 'actionsAreaId', action.payload);
    // Actionboard sub-view setters — write into the nested actionboard slice.
    case 'page/improvements/SET_ACTIONBOARD_SELECTED_WEEK':
      return R.setPath(state, ['actionboard', 'selectedWeek'], action.payload);
    case 'page/improvements/SET_ACTIONBOARD_SELECTED_ENTITY_ID':
      return R.setPath(
        state,
        ['actionboard', 'selectedEntityId'],
        action.payload,
      );
    default:
      return state;
  }
};

export default improvementsReducer;
